// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"SwiperCommon_thecomp__uIZyO","swiperTool":"SwiperCommon_swiperTool__UEfLm"};